import { sendStructEvent } from '../../api';

interface PayloadModel {
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
    eventProperty: {
        store: string;
        userID: number;
        orderID: string;
        subcategory: string;
    };
}

export const sendCategoryMarketingCardClick = (payload: PayloadModel): void => {
    const { eventLabel, eventAction, eventProperty, eventCategory } = payload;
    sendStructEvent({
        eventCategory,
        eventAction,
        eventLabel,
        eventProperty,
    });
};
